var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"set-configuration"}},[_c('configurationTree',{attrs:{"isReadOnly":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }